var moment = require('moment');
require('../../../node_modules/moment/locale/pt-br');

module.exports = moment;